import { StartupSettings } from "./types"

export const defaultSettings: StartupSettings = {
  maxRetries: 3,
  baseDelayMs: 100,
  maxDelayMs: 2000,
  backoffMultiplier: 2,
  jitterFactor: 0.1
}
